export default "__VITE_ASSET__BtcKN6I___"